// extracted by mini-css-extract-plugin
export var component = "Header-module--component--uJHQ9";
export var inner = "Header-module--inner--METru";